module.exports = __webpack_public_path__ + "static/media/CV.3ef7bbda.pdf";